<script>
import Link from '@/components/lavender/v2/BaseLink.vue'

export default {
  name: 'SupportFooter',
  components: {
    Link,
  },
}
</script>

<template>
  <Link
    to="partner.care@tamara.co"
    class="support-footer"
    track-id="sidebar_support_email"
  >
    <svg-icon name="email" width="16px" height="16px" />
    <span class="tamara-english-regular-4">partner.care@tamara.co</span>
  </Link>
</template>
